import React from 'react';
import { Icon } from '@iconify/react';
import Select from 'react-select';

export const renderDropdownMulti = (data) => {
  let values = [];

  if (Array.isArray(data)) {
    values = data;
  } else if (typeof data === 'string') {
    try {
      const parsed = JSON.parse(data);
      if (Array.isArray(parsed)) {
        values = parsed;
      }
    } catch (error) {
      values = data
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean);
    }
  }

  if (!values.length) {
    return null;
  }

  return (
    <ul className="mb-0 ps-20">
      {values.map((value, index) => (
        <li key={`${value}-${index}`}>{value}</li>
      ))}
    </ul>
  );
};

export const renderPreviewInput = (item, getInputType) => {
  const type = getInputType(item.formInputTypeId);
  if (item.heading === 1) return null;

  let inputElement = null;
  switch (type) {
    case 'text':
    case 'value':
    case 'meterreading':
      return (
        <div>
          <input type="text" className="form-control" disabled />
          {!item.disableComments && (
            <div className='text-sm text-primary mt-12'>
              <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
              Add Comment
            </div>
          )}
          {item.includePhoto ? (
            <button
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
              style={{ borderStyle: 'dashed' }}
              disabled
            >
              <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
              <span className="text-black">+ Add Photo</span>
            </button>
          ) : null}
        </div>);
    case 'textbox':
      return (
        <div>
          <textarea className="form-control" rows="3" disabled />
          {!item.disableComments && (
            <div className='text-sm text-primary mt-12'>
              <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
              Add Comment
            </div>
          )}
          {item.includePhoto ? (
            <button
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
              style={{ borderStyle: 'dashed' }}
              disabled
            >
              <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
              <span className="text-black">+ Add Photo</span>
            </button>
          ) : null}
        </div>);
    case 'date':
      inputElement = <input type="date" className="form-control" disabled />;
      break;
    case 'datetime':
    case 'datetime-local':
      inputElement = <input type="datetime-local" className="form-control" disabled />;
      break;
    case 'checkbox':
      inputElement = (
        <div className="form-check">
          <input type="checkbox" className="form-check-input" disabled />
        </div>
      );
      break;
    case 'photo':
      inputElement = (
        <button
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1"
          style={{ borderStyle: 'dashed' }}
          disabled
        >
          <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
          <span className="text-black">Take Photo</span>
        </button>
      );
      break;
    case 'signature':
      inputElement = (
        <div
          style={{ width: '100%', height: '140px', border: '1px solid #ccc', borderRadius: '8px' }}
        />
      );
      break;
    case 'note':
      inputElement = <textarea className="form-control" disabled rows={3}></textarea>;
      break;
    case 'yesno':
      return (
        <>
          <div className="d-flex gap-1">
            <button className="btn btn-outline-success btn-sm" disabled>
              Yes
            </button>
            <button className="btn btn-outline-danger btn-sm" disabled>
              No
            </button>
          </div>
          {!item.disableComments && (
            <div className='text-sm text-primary mt-12'>
              <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
              Add Comment
            </div>
          )}
          {item.includePhoto ? (
            <button
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
              style={{ borderStyle: 'dashed' }}
              disabled
            >
              <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
              <span className="text-black">+ Add Photo</span>
            </button>
          ) : null}
        </>
      );
      break;
    case 'okdefect':
      return (
        <>
          <div className="d-flex gap-1">
            <button className="btn btn-outline-success btn-sm" disabled>
              OK
            </button>
            <button className="btn btn-outline-danger btn-sm" disabled>
              Defect
            </button>
          </div>
          {!item.disableComments && (
            <div className='text-sm text-primary mt-12'>
              <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
              Add Comment
            </div>
          )}
          {item.includePhoto ? (
            <button
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
              style={{ borderStyle: 'dashed' }}
              disabled
            >
              <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
              <span className="text-black">+ Add Photo</span>
            </button>
          ) : null}
        </>
      );
      break;
    case 'passfail':
      return (
        <>
          <div className="d-flex gap-1">
            <button className="btn btn-outline-success btn-sm" disabled>
              Pass
            </button>
            <button className="btn btn-outline-danger btn-sm" disabled>
              Fail
            </button>
            <button className="btn btn-outline-warning btn-sm" disabled>
              Review
            </button>
          </div>
          {!item.disableComments && (
            <div className='text-sm text-primary mt-12'>
              <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
              Add Comment
            </div>
          )}
          {item.includePhoto ? (
            <button
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
              style={{ borderStyle: 'dashed' }}
              disabled
            >
              <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
              <span className="text-black">+ Add Photo</span>
            </button>
          ) : null}
        </>
      );
      break;
    case 'workrequest':
      return (
        <>
          <button className="btn btn-primary btn-sm" disabled>
            Add Work Request
          </button>
          {!item.disableComments && (
            <div className='text-sm text-primary mt-12'>
              <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
              Add Comment
            </div>
          )}
          {item.includePhoto ? (
            <button
              className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
              style={{ borderStyle: 'dashed' }}
              disabled
            >
              <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
              <span className="text-black">+ Add Photo</span>
            </button>
          ) : null}
        </>
      );
    case 'dropdown':
      {
        const options = Array.isArray(item.data)
          ? item.data.map((v) => ({ value: v, label: v }))
          : [];
        inputElement = (
          <Select classNamePrefix="react-select" isDisabled options={options} />
        );
      }
      break;
    case 'dropdownmulti':
      inputElement = renderDropdownMulti(item.data);
      break;
    case 'assetdetails':
    case 'areadetails':
    case 'customerdetails':
    case 'projectdetails':
      inputElement = <Select classNamePrefix="react-select" isDisabled options={[]} />;
      break;

    default:
      inputElement = null;
  }

  return (
    <>
      {inputElement}
      {!item.disableComments && (
        <div className='text-sm text-primary mt-12'>
          <Icon icon="mage:plus" className="text-lg me-4" style={{ position: 'relative', top: '-3px' }} />
          Add Comment
        </div>
      )}
      {item.includePhoto ? (
        <button
          className="btn btn-outline-secondary btn-sm d-flex align-items-center gap-1 mt-12"
          style={{ borderStyle: 'dashed' }}
          disabled
        >
          <Icon icon="mage:image" className="icon fs-6 text-black" />{' '}
          <span className="text-black">+ Add Photo</span>
        </button>
      ) : null}
    </>
  );
};
